import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import CadastrarInsumoRecord from '@components/InsumoRecord/CadastrarInsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';
import { withRouter } from 'react-router-dom';

/**
 * Tela para cadastro de Fungicida Microbiologicos
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function EditarFungicidaMicrobiologicos(props) {
  useEffect(() => {
    const title = 'fungicidaMicroBio.cadastroDeFungicidaMicroBio';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <CadastrarInsumoRecord
      id={props.match.params.id}
      insumoURL={'fungicidas-microbiologicos'}
      insumoEnum={Insumo.FUNGICIDA_MICROBIOLOGICO}
      infoUsuario={props.infoUsuario}
      saveMessage={formatMessage(
        'fungicidaMicroBio.' +
          (props.match.params.id
            ? 'fungicidaMicroBioEditadoComSucesso'
            : 'fungicidaMicroBioCadastradoComSucesso')
      )}
      falhaSaveMesssage={formatMessage(
        'fungicidaMicroBio.' +
          (props.match.params.id
            ? 'falhaAoEditarFungicidaMicroBio'
            : 'falhaAoCadastrarFungicidaMicroBio')
      )}
      falhaCarregarMensagem={formatMessage('fungicidaMicroBio.falhaAoCarregarFungicidaMicroBio')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info
});

export default withRouter(connect(mapStateToProps)(EditarFungicidaMicrobiologicos));
